import { useEffect, useRef } from "react"
import { Link, useLocation } from "react-location";
import useIsMobile from '../Layout/useIsMobile';
import Accordion from '../Accordion';
import Presentation from '../Presentation';

import './PageAbout.scss';

export const PageAbout = () => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const contactRef = useRef(null);
  const designText = "Je construis des expériences utiles avant tout, en restant attentive aux besoins utilisateurs mais, aussi aqqà mes propres intuitions.";
  const detailSenseText = "J’ai un œil UI affûté. Je cherche toujours à équilibrer esthétique et fonctionnalité, avec une attention particulière aux micro-interactions et aux hiérarchies visuelles.";
  const iterationText = "Je teste, j’ajuste, je recommence. Je n’ai pas peur d’itérer, c’est dans la confrontation des idées que le design devient juste.";
  const rigorText = "Je creuse chaque décision de design jusqu’à sa justification. Ce qui m’intéresse, ce n’est pas juste comment, mais surtout pourquoi. ";

  useEffect(() => {
    const splittedUrl = location.current?.href?.split("#");

    if (splittedUrl?.[1] === "contact" && contactRef.current) {
      setTimeout(() => window.scrollTo({ top: contactRef.current.offsetTop, behavior: "smooth" }), 100);
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  });

  return (
    <div className="about-page">
      <Presentation
        alt="About icon"
        buttons={[
          { link: "/#projets", linkType: "internal", text: "VOIR LES PROJETS", type: "white" },
          { link: "mailto:leapicault@gmail.com", linkType: "External", text: "CONTACT", type: "transparency" },
        ]}
        classSuffix="about"
        description={"Un design, ce n’est jamais juste une jolie maquette. C’est une intention, un contexte, un problème à résoudre. Voici les projets où j’ai mis l’utilisateur au cœur de chaque décision."}
        image={isMobile ? "/images/VisualIdentity/icon-mobile.svg" : "/images/VisualIdentity/icon.svg"}
        title="À propos"
      />

      <div className="about" style={{ backgroundImage: isMobile ? "" : "url(\"images/About/about-background.svg\")" }}>
        <div className="about-content">
          <div className="about-portrait-wrapper">
            <img className="about-portrait" src="images/lea-picault.png" alt="Léa Picault" />

            <div>
              <h2 className="about-portrait__title">Léa PICAULT</h2>
              <h3 className="about-portrait__subtitle">PRODUCT DESIGNER</h3>
              <p className="about-portrait__presentation">
                Je suis Product Designer, spécialisée dans la création de parcours utilisateurs clairs, engageants et alignés
                avec les enjeux business. J’interviens sur des projets variés, du e-commerce au service public, avec une
                approche centrée sur l’humain.
              </p>
              <p className="about-portrait__objective">👉 Objectif : capter rapidement l’attention sans trop en dire.</p>
            </div>
          </div>

          <div className="about-wrapper">
            <h3 className="about__title">Qui suis-je ?</h3>
            <p className="about__presentation">
              Actuellement chez Blissim en tant que Product Designer, où j’ai la responsabilité complète du design produit.
              Seule à bord côté Design, je navigue entre les enjeux tech, métier et utilisateur avec un objectif clair :
              concevoir des expériences utiles, cohérentes, et alignées avec les besoins business.
            </p>

            <div className="about__presentation--wrapper">
              <Accordion
                accordionName="accordion--about__rigor"
                content={rigorText}
                label="Esprit critique & rigueur"
              >
                <div>
                  <h4 className="about__presentation--title">🧠 Esprit critique & rigueur</h4>
                  <p className="about__presentation">{rigorText}</p>
                </div>
              </Accordion>

              <Accordion
                accordionName="accordion--about__detail-sense"
                content={detailSenseText}
                label="Sens du détail & équilibre visuel"
              >
                <div>
                  <h4 className="about__presentation--title">🎨 Sens du détail & équilibre visuel</h4>
                  <p className="about__presentation">{detailSenseText}</p>
                </div>
              </Accordion>
            </div>

            <div className="about__presentation--wrapper">
              <Accordion
                accordionName="accordion--about__iteration"
                content={iterationText}
                label="Goût pour l’itération"
              >
                <div>
                  <h4 className="about__presentation--title">🔁 Goût pour l’itération</h4>
                  <p className="about__presentation">{iterationText}</p>
                </div>
              </Accordion>

              <Accordion
                accordionName="accordion--about__design"
                content={designText}
                label="Design à l’écoute"
              >
                <div>
                  <h4 className="about__presentation--title">👂 Design à l’écoute</h4>
                  <p className="about__presentation">{designText}</p>
                </div>
              </Accordion>
            </div>

            <div className="about__collaboration--wrapper" id="contact" ref={contactRef}>
              <h3 className="about__collaboration-catch-phrase">👋 Une envie de collaborer ? N’hésitez pas à me contacter ou à consulter mes projets.</h3>

              <div className="about__collaboration--contacts">
                <a className="about__collaboration--contacts-link" href="mailto:leapicault@gmail.com">
                  <img className="about-contact--card__icon" src="/images/icon-email.svg" alt="email icon" />
                  <div className="about-contact--card__name">leapicault@gmail.com</div>
                </a>

                <a className="about__collaboration--contacts-link" href="https://www.linkedin.com/in/leapicault/" target='_blank' rel="noreferrer">
                  <img className="about-contact--card__icon" src="/images/icon-linkedin.svg" alt="linkedin icon" />
                  <div className="about-contact--card__name">leapicault</div>
                </a>

                <a className="about__collaboration--contacts-link" href="https://www.behance.net/leapicault" target='_blank' rel="noreferrer">
                  <img className="about-contact--card__icon" src="/images/icon-behance.svg" alt="linkedin icon" />
                  <div className="about-contact--card__name">leapicault</div>
                </a>
              </div>
            </div>

            <section className="about--buttons">
              <Link className="about--button button__dark" to="/#projets">DÉCOUVRIR LES PROJETS</Link>
              <a className="about--button button__light" href="/files/CV_Lea_Picault.pdf" download>TÉLÉCHARGER CV</a>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageAbout;